import React from 'react';
import * as S from './Loader.styles';
import * as T from './Loader.types';

export const Loader = ({ dataTestId, size = 'm', hasPrimaryColor }: T.LoaderTypes) => (
  <S.Loader size={size} data-testid={dataTestId} viewBox="0 0 50 50">
    <S.Circle cx="25" cy="25" r="20" size={size} hasPrimaryColor={hasPrimaryColor} />
  </S.Loader>
);
